import { connect } from 'react-redux';

import { StoreState } from '../../../../reducers';
import SpreadBackgroundPanel from '../../../../components/Editor/EditPanel/SpreadBackgroundPanel';
import { getSpreadBgData, getGeneralBgData } from '../../selectors';
import { BackgroundMediaData } from '../../reducer';

const getImportManagerId = (page: number): string => {
	const prefix = 'bgMedia';
	return `${prefix}-${page}`;
};

const mapStateToProps = (state: StoreState) => {
	const {
		editor: {
			pagesController: { spreads, currentSpreadIndex },
		},
		importManager: { byId },
	} = state;
	const spread = spreads[currentSpreadIndex];
	const page = spread[0];

	const backgroundData = getSpreadBgData(state, spread) || getGeneralBgData(state);
	let currentBgMediaData: BackgroundMediaData | undefined;
	let defaultBgMediaData: BackgroundMediaData | undefined;

	if (backgroundData) {
		currentBgMediaData = backgroundData.currentMedia;
		defaultBgMediaData = backgroundData.defaultMedia;
	}

	const importManagerId = getImportManagerId(page);

	return {
		spread,
		currentBgMediaData,
		hasCustomBgMediaData: !!defaultBgMediaData,
		isGeneralBgData: !getSpreadBgData(state, spread) && !!getGeneralBgData(state),
		importManagerId,
		isImporting: !!byId[importManagerId],
	};
};

export default connect(mapStateToProps)(SpreadBackgroundPanel);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/EditPanel/SpreadBackgroundPanel/index.tsx